export const SD_FEEDBACK = '/feedback_poll/' as const

export const SD_FEEDBACK_RESPONSE = `${SD_FEEDBACK}response/` as const
export const SD_FEEDBACK_RESPONSE_ALL = `${SD_FEEDBACK_RESPONSE}all` as const

export const SD_FEEDBACK_EVALUATION_CAMPAIGN = `${SD_FEEDBACK}evaluation_campaign/` as const
export const SD_FEEDBACK_EVALUATION_CAMPAIGN_CURRENT = `${SD_FEEDBACK_EVALUATION_CAMPAIGN}current` as const

export const SD_FEEDBACK_EVALUATION = `${SD_FEEDBACK}evaluation/` as const
export const SD_FEEDBACK_EVALUATION_BY_EVALUATOR = `${SD_FEEDBACK_EVALUATION}evaluator_subject` as const
export const SD_FEEDBACK_EVALUATION_BY_SUBJECT = `${SD_FEEDBACK_EVALUATION}subject` as const
export const SD_FEEDBACK_EVALUATION_EVALUATE_INFO = `${SD_FEEDBACK_EVALUATION}evaluate_info` as const
export const SD_FEEDBACK_EVALUATION_STATS_OPEN_ENDED = `${SD_FEEDBACK_EVALUATION}stats/open_ended` as const
export const SD_FEEDBACK_EVALUATION_STATS = `${SD_FEEDBACK_EVALUATION}stats` as const

export const SD_FEEDBACK_QUESTION = `${SD_FEEDBACK}question/` as const
export const SD_FEEDBACK_QUESTION_ALL = `${SD_FEEDBACK_QUESTION}all` as const

export const SD_FEEDBACK_STAFF_ASSIGN = `${SD_FEEDBACK}staff_assign/` as const
export const SD_FEEDBACK_STAFF_ASSIGN_STAFF = `${SD_FEEDBACK_STAFF_ASSIGN}staff` as const
export const SD_FEEDBACK_STAFF_ASSIGN_PRINCIPAL = `${SD_FEEDBACK_STAFF_ASSIGN}principal` as const

export const SD_FEEDBACK_STAFF_ASSIGN_SUBJECT_ALL = `${SD_FEEDBACK_STAFF_ASSIGN}subject/all` as const
export const SD_FEEDBACK_STAFF_ASSIGNED_EVALUATORS_ALL = `${SD_FEEDBACK_STAFF_ASSIGN}assigned_evaluators/all` as const
